import { useEffect, useState } from 'react'
import { Box, Card, CardBody, Skeleton, Table, Thead, Tbody, Tr, Th, Td, Progress } from '@chakra-ui/react'
import ReportPageHeader from '@/components/reports/ReportPageHeader'
import { helpdeskReportService, type ReportFilters } from '@/lib/services/helpdeskReportService'
export default function AgentPerformancePage() {
  const [filters, setFilters] = useState<ReportFilters>({})
  const [agents, setAgents] = useState<Array<Record<string, string | number | null>>>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    helpdeskReportService
      .getAgents(filters, 1, 50)
      .then((res) => setAgents(res.data ?? []))
      .finally(() => setLoading(false))
  }, [filters.from, filters.to])

  return (
    <Box p={4}>
      <ReportPageHeader
        title="Agent Performance"
        subtitle="Leaderboard by open tickets, FRT, and SLA compliance"
        reportType="agents"
        filters={filters}
        onFiltersChange={setFilters}
      />

      <Card>
        <CardBody overflowX="auto">
          {loading ? (
            <Skeleton height="240px" />
          ) : (
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Agent</Th>
                  <Th>Team</Th>
                  <Th>Open</Th>
                  <Th>Resolved</Th>
                  <Th>Avg FRT</Th>
                  <Th>SLA %</Th>
                  <Th>Breached</Th>
                  <Th>Load</Th>
                </Tr>
              </Thead>
              <Tbody>
                {agents.map((a) => (
                  <Tr key={String(a.agent_id)}>
                    <Td>{a.name}</Td>
                    <Td>{a.team}</Td>
                    <Td>{a.open_ticket}</Td>
                    <Td>{a.resolved_count}</Td>
                    <Td>
                      {Number(a.avg_frt_seconds) >= 60
                        ? `${Math.floor(Number(a.avg_frt_seconds) / 60)}m`
                        : `${a.avg_frt_seconds}s`}
                    </Td>
                    <Td>{a.sla_compliance_percent}%</Td>
                    <Td>{a.tickets_breached}</Td>
                    <Td>
                      <Progress value={Number(a.load_percent)} size="sm" w="80px" colorScheme="blue" />
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </CardBody>
      </Card>
    </Box>
  )
}
